var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"name-text",on:{"click":_vm.onClickNameLink}},[_vm._v(_vm._s(_vm.displayName))]),_c('div',{staticClass:"meta-line"},[_c('span',[_vm._v(_vm._s(_vm.displayCompany))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }